import axios from 'axios';

export default async function hardResetCart(p_cart_number, releventUrl) {
    try {
        const data = {
            cart_number: p_cart_number ? p_cart_number : 10,
        }
        const response = await axios.post(releventUrl + `/admin/setCartReset`, data);

        if (response.status === 200) {
            return response.data;
        } else {
            console.log("ERROR hardResetCart");
            return 'error';
        }
    } catch (error) {
        console.log("ERROR hardResetCart", error);
        return 'error';
    }
}
